const parseMoneyString = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const cleaned = value.replace(/[^\d,.-]/g, '').replace(',', '.');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

const parseCurrencyToFloat = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    return parseFloat(
      value
        .replace("R$", "")
        .trim()
        .replace(/\./g, "")
        .replace(",", ".")
    );
  }
  return 0;
};

const formatDataForSave = (stepData, keys) => {
  const data = {};
  keys.forEach(key => {
    data[key] = parseCurrencyToFloat(stepData[key]);
  });
  return { data };
};

export function formatStep2ForSave(stepData) {
  return formatDataForSave(stepData, ['cif', 'cmp', 'cms', 'rtp', 'rts']);
}

export function formatStep3ForSave(stepData) {
  return {
    data: {
      cc: {
        pdt: parseMoneyString(stepData.cc.pdt),
        pdrt: parseMoneyString(stepData.cc.pdrt),
      },
      ci: {
        pdt: parseMoneyString(stepData.ci.pdt),
        pdrt: parseMoneyString(stepData.ci.pdrt),
      },
      ou: {
        pdt: parseMoneyString(stepData.ou.pdt),
        pdrt: parseMoneyString(stepData.ou.pdrt),
      },
      tcc: {
        pdt: parseMoneyString(stepData.tcc.pdt),
        pdrt: parseMoneyString(stepData.tcc.pdrt),
      },
      tcd: {
        pdt: parseMoneyString(stepData.tcd.pdt),
        pdrt: parseMoneyString(stepData.tcd.pdrt),
      },
    }
  };
}

export function formatStep4ForSave(stepData) {
  return formatDataForSave(stepData, ['cgp', 'iif']);
}

export function formatStep5ForSave(stepData) {
  const parsedArray = stepData.map(item => ({
    order: item.order,
    value: item.value,
  }));

  return {
    data: {
      pdr: parsedArray
    }
  };
}

export function formatStep6ForSave(stepData) {
  const parsedArray = stepData.map(item => ({
    order: item.order,
    deadline: Number(item.deadline),
    value: parseMoneyString(item.value),
  }));

  return {
    data: {
      pdc: parsedArray
    }
  };
}

export function formatStep7ForSave(stepData) {
  const parsedArray = stepData.map(item => ({
    order: item.order,
    days: Number(item.days),
    value: parseMoneyString(item.value),
  }));

  return {
    data: {
      gde: parsedArray
    }
  };
}

export function formatStep9ForSave(stepData) {
  const monthData = stepData[0];
  const mes = monthData?.mes || "";
  const entries = monthData?.entries || [];

  return {
    data: {
      fluxo: {
        saidas: [
          {
            mes: mes,
            entries: entries.map((item) => ({ 
              uuid: item.uuid, 
              pago: item.pago,
              title: item.title,
              val: item.val
            }))
          }
        ]
      }
    }
  };
}

export function formatCloseMonthData(steps) {
  const formatters = {
    step2: formatStep2ForSave,
    step3: formatStep3ForSave,
    step4: formatStep4ForSave,
    step5: formatStep5ForSave,
    step6: formatStep6ForSave,
    step7: formatStep7ForSave,
    step9: formatStep9ForSave,
  }

  return {
    data: Object.entries(steps).reduce((acc, [stepKey, stepData]) => {
      if (formatters[stepKey] && stepData) {
        const formatted = formatters[stepKey](stepData);
        Object.assign(acc, formatted.data);
      }
      return acc;
    }, {})
  }
};
